import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	assetOverrides: {
		base: {
			accordionPanel: {
				collapseIcon: 'AccordionCollapseIcon.svg',
				expandIcon: 'AccordionExpandIcon.svg',
			},
			tooltip: {
				defaultIcon: 'InformationIcon.svg',
			},
		},
		overview: {
			changeIndicator: {
				changeDownIcon: 'ChangeDownIcon.svg',
				changeUpIcon: 'ChangeUpIcon.svg',
			},
		},
	},
	components: {
		app: {
			cardProps: {
				props: {
					title: 'Fund Facts',
				},
				queries: {},
			},
			gridProps: {
				breakpoints: [
					{
						modifier: 'down',
						props: {
							grid: {
								rows: [
									{
										columns: [
											{
												components: [
													{
														key: 'product.list',
														props: {
															mode: 'accordion',
														},
													},
													{
														key:
															'priceAndYield.list',
														props: {
															mode: 'accordion',
														},
													},
													{
														key: 'srri.list',
														props: {
															mode: 'accordion',
														},
													},
													{
														key:
															'chargesAndInvesting.list',
														props: {
															mode: 'accordion',
														},
													},
													{
														key: 'identifiers.list',
														props: {
															mode: 'accordion',
														},
													},
													{
														key:
															'distributionDates.list',
														props: {
															mode: 'accordion',
														},
													},
												],
												style: {
													width: '100%',
												},
											},
										],
									},
								],
							},
						},
						size: 'small',
					},
					{
						modifier: 'up',
						props: {
							grid: {
								rows: [
									{
										columns: [
											{
												components: [
													{
														key: 'product.list',
													},
													{
														key:
															'chargesAndInvesting.list',
													},
													{
														key: 'srri.list',
													},
												],
												style: {
													flex: {
														_value: '1',
													},
													margin: {
														right: '30px',
													},
												},
											},
											{
												components: [
													{
														key:
															'priceAndYield.list',
													},
													{
														key: 'identifiers.list',
													},
													{
														key:
															'distributionDates.list',
													},
												],
												style: {
													flex: {
														_value: '1',
													},
													margin: {
														left: '30px',
														right: '0px',
													},
												},
											},
										],
									},
								],
							},
						},
						size: 'medium',
					},
				],
			},
			globalInputIdentifiers: [
				'my-custom-input',
			],
		},
		factLists: [
			{
				items: [
					{
						props: {
							dataType: 'app-asset',
							title: 'Citywire Rating',
						},
						queries: {
							appAssetProps: {
								src: {
									queryOptionsType: 'asset',
									key: 'citywire_AAA_large.png',
									assetOptions: {
										source: 'ksysAsset',
									},
								},
							},
						},
					},
					{
						props: {
							title: 'Capability',
						},
						queries: {
							value: {
								code: 'combined_capability',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Product Type',
						},
						queries: {
							value: {
								code: 'product_type',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							dataType: 'date',
							title: 'Share Class Launch Date',
						},
						queries: {
							value: {
								code: 'share_class_launch_date',
								entityType: 'CLSS',
								format: {
									options: {
										day: '2-digit',
										month: 'short',
										year: 'numeric',
									},
									type: 'date',
								},
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							dataType: 'date',
							title: 'Fund Launch Date',
						},
						queries: {
							value: {
								code: 'fund_launch_date',
								entityType: 'CLSS',
								format: {
									options: {
										day: '2-digit',
										month: 'short',
										year: 'numeric',
									},
									type: 'date',
								},
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Domicile',
						},
						queries: {
							value: {
								code: 'domicile',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							title: 'Benchmark',
						},
						queries: {
							value: {
								code: 'benchmark_name',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							title: 'Benchmark Type',
						},
						queries: {
							value: {
								code: 'benchmark_type',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Fund Base Currency',
						},
						queries: {
							value: {
								code: 'fund_currency',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Share Class Currency',
						},
						queries: {
							value: {
								code: 'share_class_currency',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Distribution Type',
						},
						queries: {
							value: {
								code: 'distribution_type',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
				],
				key: 'product.list',
				props: {
					heading: 'Product',
				},
				queries: {},
			},
			{
				items: [
					{
						props: {
							subtitle: {
								text: 'as at {date}',
								showBlank: false,
								placeholderText: 'N/A',
							},
							title: 'Ongoing Charge',
							tooltip: {
								title: {
									position: 'top',
								},
							},
						},
						queries: {
							subtitle: {
								date: {
									code: 'ongoing_charge_date',
									entityType: 'CLSS',
									queryOptionsType: 'property',
								},
							},
							tooltip: {
								title: {
									content: {
										key: 'ongoing_charge_tooltip',
										queryOptionsType: 'disclaimers',
									},
								},
							},
							value: {
								code: 'ongoing_charge',
								entityType: 'CLSS',
								index: 0,
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Minimum Investment',
						},
						queries: {
							value: {
								queryOptionsType: 'none',
								subQueries: [
									{
										code: 'share_class_currency',
										entityType: 'CLSS',
										index: 0,
										queryId: 'currency',
										queryOptionsType: 'property',
									},
									{
										code: 'min_investment',
										entityType: 'CLSS',
										format: {},
										index: 0,
										queryId: 'value',
										queryOptionsType: 'property',
									},
								],
								value: '{sub:currency} {sub:value}',
							},
						},
					},
				],
				key: 'chargesAndInvesting.list',
				props: {
					heading: 'Charges and Investing',
				},
				queries: {},
			},
			{
				items: [
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							dataType: 'risk-rating',
							riskRatingProps: {
								labels: {
									bottom: {
										left: 'Lower Risk',
										right: 'Higher Risk',
									},
								},
								value: 0,
							},
						},
						queries: {
							riskRatingProps: {
								value: {
									code: 'srri_risk_score',
									entityType: 'CLSS',
									queryOptionsType: 'property',
								},
							},
						},
					},
				],
				key: 'srri.list',
				props: {
					heading: 'SRRI',
					headingTooltip: {
						position: 'top',
					},
					listBlankDataOptions: {
						showBlank: false,
					},
				},
				queries: {
					headingTooltip: {
						content: {
							key: 'srri_tooltip',
							queryOptionsType: 'disclaimers',
						},
					},
				},
			},
			{
				items: [
					{
						props: {
							subtitle: {
								text: 'as at {date}',
								showBlank: false,
								placeholderText: 'N/A',
							},
							title: 'Price (NAV)',
							tooltip: {
								title: {
									position: 'top',
								},
							},
						},
						queries: {
							subtitle: {
								date: {
									code: 'daily_prices',
									entityType: 'CLSS',
									index: 0,
									key: 'price_date',
									queryOptionsType: 'statistics',
								},
							},
							tooltip: {
								title: {
									content: {
										key: 'nav_tooltip',
										queryOptionsType: 'disclaimers',
									},
								},
							},
							value: {
								index: 0,
								queryOptionsType: 'none',
								subQueries: [
									{
										code: 'share_class_currency',
										entityType: 'CLSS',
										queryId: 'currency',
										queryOptionsType: 'property',
									},
									{
										code: 'daily_prices',
										entityType: 'CLSS',
										index: 0,
										key: 'nav_price',
										queryId: 'value',
										queryOptionsType: 'statistics',
									},
								],
								value: '{sub:currency} {sub:value}',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								placeholder: '-',
								showBlank: false,
							},
							subtitle: {
								text: 'as at {date}',
								showBlank: false,
								placeholderText: 'N/A',
							},
							title: 'Bid Price',
							tooltip: {
								title: {
									position: 'top',
								},
							},
						},
						queries: {
							subtitle: {
								date: {
									code: 'daily_prices',
									entityType: 'CLSS',
									index: 0,
									key: 'price_date',
									queryOptionsType: 'statistics',
								},
							},
							tooltip: {
								title: {
									content: {
										key: 'nav_tooltip',
										queryOptionsType: 'disclaimers',
									},
								},
							},
							value: {
								index: 0,
								queryOptionsType: 'none',
								subQueries: [
									{
										code: 'share_class_currency',
										entityType: 'CLSS',
										queryId: 'currency',
										queryOptionsType: 'property',
									},
									{
										code: 'daily_prices',
										entityType: 'CLSS',
										index: 0,
										key: 'bid_price',
										queryId: 'value',
										queryOptionsType: 'statistics',
									},
								],
								value: '{sub:currency} {sub:value}',
								allSubQueryValuesRequired: true,
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							subtitle: {
								text: 'as at {date}',
								showBlank: false,
								placeholderText: 'N/A',
							},
							title: 'Offer Price',
							tooltip: {
								title: {
									position: 'top',
								},
							},
						},
						queries: {
							subtitle: {
								date: {
									code: 'daily_prices',
									entityType: 'CLSS',
									index: 0,
									key: 'price_date',
									queryOptionsType: 'statistics',
								},
							},
							tooltip: {
								title: {
									content: {
										key: 'nav_tooltip',
										queryOptionsType: 'disclaimers',
									},
								},
							},
							value: {
								index: 0,
								queryOptionsType: 'none',
								subQueries: [
									{
										code: 'share_class_currency',
										entityType: 'CLSS',
										queryId: 'currency',
										queryOptionsType: 'property',
									},
									{
										code: 'daily_prices',
										entityType: 'CLSS',
										index: 0,
										key: 'offer_price',
										queryId: 'value',
										queryOptionsType: 'statistics',
									},
								],
								value: '{sub:currency} {sub:value}',
								allSubQueryValuesRequired: true,
							},
						},
					},
					{
						props: {
							changeIndicatorProps: {
								format: '{value}',
								value: 0,
							},
							dataType: 'change-indicator',
							subtitle: {
								text: 'as at {date}',
								showBlank: false,
								placeholderText: 'N/A',
							},
							title: 'Price Change',
						},
						queries: {
							changeIndicatorProps: {
								value: {
									code: 'daily_prices',
									entityType: 'CLSS',
									index: 0,
									key: 'price_daily_change_percent',
									queryOptionsType: 'statistics',
								},
							},
							subtitle: {
								date: {
									code: 'daily_prices',
									entityType: 'CLSS',
									index: 0,
									key: 'price_date',
									queryOptionsType: 'statistics',
								},
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							subtitle: {
								text: 'as at {date}',
								showBlank: false,
								placeholderText: 'N/A',
							},
							title: 'Yield',
							tooltip: {
								title: {
									position: 'top',
								},
							},
						},
						queries: {
							subtitle: {
								date: {
									code: 'yield',
									entityType: 'CLSS',
									index: 0,
									key: 'yield_date',
									queryOptionsType: 'statistics',
								},
							},
							tooltip: {
								title: {
									content: {
										key: 'yield_tooltip',
										queryOptionsType: 'disclaimers',
									},
								},
							},
							value: {
								code: 'yield',
								entityType: 'CLSS',
								index: 0,
								key: 'yield',
								queryOptionsType: 'statistics',
							},
						},
					},
				],
				key: 'priceAndYield.list',
				props: {
					heading: 'Price and Yield',
				},
				queries: {},
			},
			{
				items: [
					{
						props: {
							title: 'ISIN',
						},
						queries: {
							value: {
								code: 'isin',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'SEDOL',
						},
						queries: {
							value: {
								code: 'sedol',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'WKN',
						},
						queries: {
							value: {
								code: 'wkn',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Bloomberg Ticker',
						},
						queries: {
							value: {
								code: 'ticker',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
				],
				key: 'identifiers.list',
				props: {
					heading: 'Identifiers',
				},
				queries: {},
			},
			{
				items: [
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Pay Dates',
						},
						queries: {
							value: {
								code: 'pay_dates',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
					{
						props: {
							blankDataOptions: {
								showBlank: false,
							},
							title: 'Ex Dates',
						},
						queries: {
							value: {
								code: 'ex_dates',
								entityType: 'CLSS',
								queryOptionsType: 'property',
							},
						},
					},
				],
				key: 'distributionDates.list',
				props: {
					heading: 'Distribution Dates',
				},
				queries: {},
			}
		],
		itemBlankDataOptions: {
			placeholder: 'N/A',
			showBlank: true,
		},
		listValueSeparator: ', ',
	},
};